import { render } from "./QuestionMark.vue?vue&type=template&id=7080cb18&scoped=true"
import script from "./QuestionMark.vue?vue&type=script&lang=js"
export * from "./QuestionMark.vue?vue&type=script&lang=js"

import "./QuestionMark.vue?vue&type=style&index=0&id=7080cb18&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7080cb18"]])

export default __exports__